import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { ProductionTechnologiesRecipes } from '../services/service/DataProviders/ProductionTechnologiesRecipes';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import * as _ from "lodash";
import { FormGroup } from '@angular/forms';
import { ProductionTechnologiesRecipeIngredients } from '../services/service/DataProviders/ProductionTechnologiesRecipeIngredients';
import { GeneralProductsProducts } from '../services/service/DataProviders/GeneralProductsProducts';

@Injectable({
    providedIn: 'root'
})


export class EditRecipes {

    public log$;
    private settings;
    private substitudes;
    private storeOptions = [];

    constructor(
        private recipeService: ProductionTechnologiesRecipes,
        private recipeIngredientService: ProductionTechnologiesRecipeIngredients,
        private productService: GeneralProductsProducts,
    ) {
        this.log$ = new Subject();
    }

    subscribeForLog() {
        return this.log$.asObservable();
    }

    async processList(list, settings: FormGroup, substitudeArray, storeOptions) {
        this.substitudes = substitudeArray;
        this.storeOptions = storeOptions;
        this.loadSettings(settings);
        for (let i = 0; i < list.length; i++) {
            await this.processOne(list[i]);
        }
    }

    async processOne(i) {
        let recipeName = _.get(i, 'Name') + ': ';
        let recipe;

        try {
            this.log$.next({ message: recipeName + 'Започвам обработка', type: 'SUCCESS' });

            //start transaction
            let transaction = await this.recipeService.beginTransaction({
                "model": "frontend",
                "trackChanges": true
            }
            );

            this.recipeIngredientService.setTransaction(transaction);
            this.productService.setTransaction(transaction);

            recipe = await this.readRecipe(i);

            if (this.settings.new === 'edit') {
                this.log$.next({ message: recipeName + 'Режим - Редакция', type: 'SUCCESS' });
                await this.editRecipe(recipe);
            }
            else if (this.settings.new === 'new') {
                this.log$.next({ message: recipeName + 'Режим - Нова', type: 'SUCCESS' });
                await this.createNewRecipeBasedOn(recipe);
            }
            else if (this.settings.new === 'copy') {
                this.log$.next({ message: recipeName + 'Режим - Копиране', type: 'SUCCESS' });
                await this.copyRecipeBasedOn(recipe);
            }
            else {
                this.log$.next({ message: recipeName + 'Режим - НЕПОЗНАТ', type: 'ERROR' });

            }

            //Запазва себестойност на продукта
            if(this.settings.SaveStandartCost) {
                const updateData = {
                    StandardCostPerLot: recipe.Product.StandardCostPerLot
                };
                console.log(updateData);
                this.log$.next({ message: recipeName + ' запазвам себестойност на ' + recipe.Product.Name.BG, recipe: recipe, type: 'SUCCESS' });

                await this.productService.storeRecord(recipe.Product.Id, updateData).pipe(take(1)).toPromise();
            }

            await this.recipeService.commitTransaction();
            this.recipeService.clearTransaction();
            this.recipeIngredientService.clearTransaction();
            this.productService.clearTransaction();
        }
        catch (e) {
            this.recipeService.clearTransaction();
            this.recipeIngredientService.clearTransaction();
            this.productService.clearTransaction();
            this.recipeService.handleError(e);
            this.log$.next({ message: recipeName + e.message, type: 'ERR' });
            recipe = await this.readRecipe(i); //за да има време за грешката
            console.error(e);
        }

        this.log$.next({ message: recipeName + 'Приключвам обработката', recipe: recipe, type: 'SUCCESS' });
        return recipe;
    }

    private loadSettings(settings: FormGroup) {
        this.settings = settings.value;
        this.settings.ExpiryDate = this.settings.ExpiryDate != null ? moment(this.settings.ExpiryDate, "DD.MM.YYYY") : null;
        this.settings.ReleaseDate = this.settings.ReleaseDate != null ? moment(this.settings.ReleaseDate, "DD.MM.YYYY") : null;
        const storeName = this.settings.Store;

        for (let i = 0; i < this.storeOptions.length; i++) {
            let store = this.storeOptions[i];
            if (store?.Name?.BG === storeName) {
                this.settings.Store = store;
                break;
            }
        }
    }

    private async readRecipe(i) {

        let getRecipeState = JSON.parse(JSON.stringify(this.recipeService.stateTemplate));
        getRecipeState.filter.filters.push({ field: 'Id', operator: 'eq', value: i['Id'] });

        let recipe = await <any>this.recipeService.filterRecipeies(getRecipeState).pipe(take(1)).toPromise();
        recipe = recipe.value[0];

        return recipe;
    }

    private async editRecipe(recipe) {

        let recipeName = _.get(recipe, 'Name') + ': ';

        let maxRowNumber = this.getMaxRowNumber(recipe);

        for (let i = 0; i < this.substitudes.length; i++) {
            let sub = this.substitudes[i];

            //добавям нови редове
            if (_.isNull(sub.source.productName) && !_.isNull(sub.replace.productName)) {
                maxRowNumber++;
                let rowData = {
                    UsageUnit: { '@odata.id': sub.replace.product.MeasurementUnit['@odata.id'] },
                    LineOrd: maxRowNumber,
                    UsageQuantity: {
                        Unit: sub.replace.product.MeasurementUnit.Code,
                        Value: sub.replace.quantity
                    },
                    Material: { '@odata.id': sub.replace.product['@odata.id'] },
                    Operation: null,
                    Recipe: { '@odata.id': recipe['@odata.id'] },
                    Store: sub.replace.store != null ? { '@odata.id': sub.replace.store['@odata.id'] } : null,
                    UnitCost: _.clone(sub.replace.product.StandardCostPerLot),
                    Cost: _.clone(sub.replace.product.StandardCostPerLot)
                };

                // попълва unitcost и cost но по някога ерп-то не ги отчита, но на база на тях смята себестойност на продукта

                if(_.has(rowData,'Cost.Value') && rowData.Cost.Value != 0) {
                    rowData.Cost.Value = _.round(rowData.Cost.Value*rowData.UsageQuantity.Value, 3);
                }

                if(rowData.Cost.Value < 0.001) {
                    rowData.Cost.Value = 0;
                }

                this.log$.next({ message: recipeName + 'Добявам ред N' + maxRowNumber, recipe: recipe, type: 'SUCCESS' });

                await this.recipeIngredientService.storeRecord(null, rowData).pipe(take(1)).toPromise();
            }
            // заменям редове
            else if (!_.isNull(sub.source.productName) && !_.isNull(sub.replace.productName)) {
                for (let j = 0; j < recipe.Ingredients.length; j++) {
                    let ing = recipe.Ingredients[j];

                    let materialInRecipe = ing['Material']['@odata.id'];
                    let quantityRecipe = ing['UsageQuantity']['Value'];
                    let materialForReplace = sub.source.product['@odata.id'];
                    let quantityForReplace = sub.source.quantity;

                    if (materialForReplace != materialInRecipe
                        || quantityRecipe != quantityForReplace
                        ) {
                        continue;
                    }

                    let id = ing['Id'];
                    let updateData = {
                        UsageUnit: { '@odata.id': sub.replace.measure['@odata.id'] },
                        UsageQuantity: {
                            Unit: sub.replace.measure.Code,
                            Value: sub.replace.quantity
                        },
                        Material: { '@odata.id': sub.replace.product['@odata.id'] },
                        Store: sub.replace.store != null ? { '@odata.id': sub.replace.store['@odata.id'] } : null,
                        UnitCost: _.clone(sub.replace.product.StandardCostPerLot),
                        Cost: _.clone(sub.replace.product.StandardCostPerLot)
                    }

                    if(_.has(updateData,'Cost.Value') && updateData.Cost.Value != 0) {
                        updateData.Cost.Value = _.round(updateData.Cost.Value*updateData.UsageQuantity.Value, 3);
                    }

                    if(updateData.Cost.Value < 0.001) {
                        updateData.Cost.Value = 0;
                    }

                    this.log$.next({ message: recipeName + 'Променям ред N' + ing['LineOrd'], recipe: recipe, type: 'SUCCESS' });
                    await this.recipeIngredientService.storeRecord(id, updateData).pipe(take(1)).toPromise();
                }

            }
            //премахвам редове
            else if (!_.isNull(sub.source.productName) && _.isNull(sub.replace.productName)) {
                for (let j = 0; j < recipe.Ingredients.length; j++) {
                    let ing = recipe.Ingredients[j];

                    let materialInRecipe = ing['Material']['@odata.id'];
                    let materialForReplace = sub.source.product['@odata.id'];

                    if (materialForReplace != materialInRecipe) {
                        continue;
                    }

                    let id = ing['Id'];

                    this.log$.next({ message: recipeName + 'Изтривам ред ред N' + ing['LineOrd'], recipe: recipe, type: 'SUCCESS' });
                    await this.recipeIngredientService.delete(id).pipe(take(1)).toPromise();
                }
            }
            else {
                console.log('substitude', sub);
                throw new Error('Непозната дефиниция. Обърнете се към администратор!');
            }
        }

    }

    private getStoreNewRecipe(recipe) {
        const storeFromRecipe = !_.isNull(recipe.Store) ? { '@odata.id': recipe.Store['@odata.id'] } : null;
        const storeFromSettings = !_.isNull(this.settings.Store) ? { '@odata.id': this.settings.Store['@odata.id'] } : null;

        if (storeFromSettings != null) {
            return storeFromSettings;
        }
        else {
            return storeFromRecipe;
        }
    }

    private async createNewRecipeBasedOn(recipe) {
        let recipeName = _.get(recipe, 'Name') + ': ';

        let maxRowNumber = this.getMaxRowNumber(recipe);

        let recepieData = {
            Product: { '@odata.id': recipe.Product['@odata.id'] },
            CurrencyDirectory: _.get(recipe, 'CurrencyDirectory', null),
            ReleaseDate: null,
            Ingredients: [],
            IsDefault: _.get(recipe, 'IsDefault', false),
            Name: _.get(recipe, 'Name', null),
            Notes: _.get(recipe, 'Notes', null),
            Price: _.get(recipe, 'Price', null),
            PricePerLot: _.get(recipe, 'PricePerLot', null),
            PrincipalRecipe: _.get(recipe, 'PrincipalRecipe', null),
            ProduceQuantity: _.get(recipe, 'ProduceQuantity', null),
            ScrapRate: _.get(recipe, 'ScrapRate', null),
            Store: this.getStoreNewRecipe(recipe),
        };

        for (let i = 0; i < recipe.Ingredients.length; i++) {
            let ing = recipe.Ingredients[i];
            let materialInRecipe = ing['Material']['@odata.id'];
            let materialQuantity = ing['UsageQuantity']['Value'];

            for (let j = 0; j < this.substitudes.length; j++) {
                let sub = this.substitudes[j];

                if(_.isNull(sub.source.product)) {
                    //тези ги прескачам защото са добавяне на нови
                    continue;
                }
                let subSourceQuantity = sub.source.quantity;
                let materialForReplace = sub.source.product['@odata.id'] ? sub.source.product['@odata.id'] : null;

                if(materialInRecipe != materialForReplace 
                    || materialQuantity != subSourceQuantity) {
                        //реда не е същия
                        continue;
                    }

                if (!_.isNull(sub.replace.product) && sub.replace.quantity != 0) {
                    //замяна
                    let rowData = {
                        UsageUnit: { '@odata.id': sub.replace.measure['@odata.id'] },
                        Material: { '@odata.id': sub.replace.product['@odata.id'] },
                        LineOrd: ing['LineOrd'],
                        UsageQuantity: {
                            Unit: sub.replace.measure.Code,
                            Value: sub.replace.quantity
                        },
                        Operation: null,
                        Store: sub.replace.store != null ? { '@odata.id': sub.replace.store['@odata.id'] } : null,
                        UnitCost: _.clone(sub.replace.product.StandardCostPerLot),
                        Cost: _.clone(sub.replace.product.StandardCostPerLot)
                    };

                    if(_.has(rowData,'Cost.Value') && rowData.Cost.Value != 0) {
                        rowData.Cost.Value = _.round(rowData.Cost.Value*rowData.UsageQuantity.Value, 3);
                    }

                    if(_.has(rowData,'Cost.Value') && rowData.Cost.Value < 0.001) {
                        rowData.Cost.Value = 0;
                    }

                    this.log$.next({ message: recipeName + 'Заменям продукт в ред N' + ing['LineOrd'], recipe: recipe, type: 'SUCCESS' });
                    recepieData.Ingredients.push(rowData);
                }
                else {
                    this.log$.next({ message: recipeName + 'Изтривам ред N' + ing['LineOrd'], recipe: recipe, type: 'SUCCESS' });
                    //изтрива - не го добавя
                    continue;
                }
            }
        }

        for (let i = 0; i < this.substitudes.length; i++) {
            let sub = this.substitudes[i];

            //добавям нови редове
            if (_.isNull(sub.source.productName) && !_.isNull(sub.replace.productName)) {
                maxRowNumber++;
                let rowData = {
                    UsageUnit: { '@odata.id': sub.replace.measure['@odata.id'] },
                    Material: { '@odata.id': sub.replace.product['@odata.id'] },
                    LineOrd: maxRowNumber,
                    UsageQuantity: {
                        Unit: sub.replace.measure.Code,
                        Value: sub.replace.quantity
                    },
                    Operation: null,
                    Store: sub.replace.store != null ? { '@odata.id': sub.replace.store['@odata.id'] } : null,
                    UnitCost: _.clone(sub.replace.product.StandardCostPerLot),
                    Cost: _.clone(sub.replace.product.StandardCostPerLot)
                };

                if(_.has(rowData,'Cost.Value') && rowData.Cost.Value != 0) {
                    rowData.Cost.Value = _.round(rowData.Cost.Value*rowData.UsageQuantity.Value, 3);
                }

                if(rowData.Cost.Value < 0.001) {
                    rowData.Cost.Value = 0;
                }

                this.log$.next({ message: recipeName + 'Добявам ред N' + maxRowNumber, recipe: recipe, type: 'SUCCESS' });
                recepieData.Ingredients.push(rowData);
            }
        }

        console.log('new doc', recepieData);
        console.log('date', this.settings.ExpiryDate);

        if (!_.isNull(this.settings.ExpiryDate)) {
            let expiryDate = this.settings.ExpiryDate.format('YYYY-MM-DD') + 'T23:59:59Z';
            await this.recipeService.storeRecord(recipe['Id'], { ExpiryDate: expiryDate }).pipe(take(1)).toPromise();
        }

        let fromDate = null;
        if (_.isNull(this.settings.ReleaseDate)) {
            fromDate = this.settings.ExpiryDate.clone().add(1, 'd').format('YYYY-MM-DD') + 'T00:00:00Z';
        }
        else {
            fromDate = this.settings.ReleaseDate.format('YYYY-MM-DD') + 'T00:00:00Z';
        }
        recepieData.ReleaseDate = fromDate;

        return await this.recipeService.storeRecord(null, recepieData).pipe(take(1)).toPromise();
    }

    private async copyRecipeBasedOn(recipe) {
        let recipeName = _.get(recipe, 'Name') + ': ';

        let maxRowNumber = this.getMaxRowNumber(recipe);

        let recepieData = {
            Product: { '@odata.id': recipe.Product['@odata.id'] },
            CurrencyDirectory: _.get(recipe, 'CurrencyDirectory', null),
            ReleaseDate: null,
            Ingredients: [],
            IsDefault: _.get(recipe, 'IsDefault', false),
            Name: _.get(recipe, 'Name', null),
            Notes: _.get(recipe, 'Notes', null),
            Price: _.get(recipe, 'Price', null),
            PricePerLot: _.get(recipe, 'PricePerLot', null),
            PrincipalRecipe: _.get(recipe, 'PrincipalRecipe', null),
            ProduceQuantity: _.get(recipe, 'ProduceQuantity', null),
            ScrapRate: _.get(recipe, 'ScrapRate', null),
            Store: this.getStoreNewRecipe(recipe),
        };

        for (let i = 0; i < recipe.Ingredients.length; i++) {
            let ing = recipe.Ingredients[i];
            maxRowNumber++;
            let rowData = {
                UsageUnit: { '@odata.id': ing['UsageUnit']['@odata.id'] },
                Material: { '@odata.id': ing['Material']['@odata.id'] },
                LineOrd: maxRowNumber,
                UsageQuantity: ing['UsageQuantity'],
                Operation: ing['Operation'],
                Store: ing['Store'],
                UnitCost: _.clone(ing['Material']['StandardCostPerLot']),
                Cost: _.clone(ing['Material']['StandardCostPerLot'])
            };

            if(_.has(rowData,'Cost.Value') && rowData.Cost.Value != 0) {
                rowData.Cost.Value = _.round(rowData.Cost.Value*rowData.UsageQuantity.Value, 3);
            }

            if(rowData.Cost.Value < 0.001) {
                rowData.Cost.Value = 0;
            }

            // this.log$.next({ message: recipeName + 'Добявам ред N' + maxRowNumber, recipe: recipe, type: 'SUCCESS' });
            recepieData.Ingredients.push(rowData);
        }

        console.log('copy doc', recepieData);

        let fromDate = null;
        if (_.isNull(this.settings.ReleaseDate)) {
            fromDate = this.settings.ExpiryDate.clone().add(1, 'd').format('YYYY-MM-DD') + 'T00:00:00Z';
        }
        else {
            fromDate = this.settings.ReleaseDate.format('YYYY-MM-DD') + 'T00:00:00Z';
        }
        recepieData.ReleaseDate = fromDate;

        return await this.recipeService.storeRecord(null, recepieData).pipe(take(1)).toPromise();
    }

    private getMaxRowNumber(recipe) {
        let maxRowNumber = 0;
        recipe.Ingredients.forEach(i => {
            if (_.get(i, 'LineOrd', 0) > maxRowNumber) {
                maxRowNumber = _.get(i, 'LineOrd', 0);
            }
        });

        return maxRowNumber;
    }



}


